import React from 'react';
import { t } from 'i18next';
import { connect } from 'react-redux';
import logoColourOnBlack from '../../../assets/logo/logoColourOnBlack.svg';
import iconFacebook from '../../../assets/icons/Facebook.svg';
import iconLinkedIn from '../../../assets/icons/LinkedIn.svg';
import iconPhone from '../../../assets/icons/Phone.svg';
import iconEmail from '../../../assets/icons/Email.svg';
import iconChat from '../../../assets/icons/Chat.svg';
import { Link, MainFooter, MarginlessP } from './css';
import SalesForceChat from '../ChatWindow/SalesForceChat';
import { Locales, SalesforceChatLanguages } from '../../../utils/enums';

const Footer = () => {
  const handleLanguageSwitch = (type) => {
    let url;
    const locale = window.location.pathname.toLowerCase().includes(`/${Locales.French.toLowerCase()}/`) ? 'fr-CA' : 'en';
    if (locale === 'fr-CA') {
      if (type === 'privacy') {
        url = 'https://dayross.com/fr-CA/privacy-policy';
      } else {
        url = 'https://dayross.com/fr-CA/accessibility';
      }
    } else if (type === 'privacy') {
      url = 'https://dayross.com/en/privacy-policy';
    } else {
      url = 'https://dayross.com/accessibility';
    }

    window.open(url, '_blank');
  };

  return (
    <MainFooter>
      <div className="row">
        <div className="col-md-2 col-sm-12">
          <a className="navbar-brand" href="/"><img src={logoColourOnBlack} alt="Day & Ross" /></a>
        </div>

        <div className="col-md-2 col-sm-12">
          <nav className="nav flex-column footer-column">
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <a className="nav-link small text-white" href="/track-shipments">
              <MarginlessP field={t('Tracking')} />
            </a>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <a className="nav-link small text-white" href="/about-us">
              <MarginlessP field={t('AboutUs')} />
            </a>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <a className="nav-link small text-white" href="/careers">
              <MarginlessP field={t('Careers')} />
            </a>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <a className="nav-link small text-white" href="https://www.mccain.com">
              <MarginlessP field={t('McCainFoods')} />
            </a>
          </nav>
        </div>

        <div className="col-md-2 col-sm-12">
          <nav className="nav flex-column footer-column">
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <a className="nav-link small text-white" rel="noopener noreferrer" target="_blank" href="https://www.mccain.com/terms-and-conditions/">
              <MarginlessP field={t('TermsAndConditions')} />
            </a>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
            <span className="nav-link small text-white pointer" onClick={() => handleLanguageSwitch('privacy')}>
              <MarginlessP field={t('PrivacyPolicy')} />
            </span>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
            <span className="nav-link small text-white pointer" onClick={() => handleLanguageSwitch('accessibility')}>
              <MarginlessP field={t('Accessibility')} />
            </span>
            <div>
              <a className="nav-link small text-white social-media" href="https://www.facebook.com/DayRossInc/">
                <img src={iconFacebook} alt="facebook" />
              </a>
              <a className="nav-link small text-white social-media" href="https://www.linkedin.com/company/day-&-ross-general-freight">
                <img src={iconLinkedIn} alt="linkedin" />
              </a>
            </div>
          </nav>
        </div>

        <div className="col-md-6 col-sm-12 contact-box">
          <nav className="nav flex-column footer-column">
            <Link
              className="nav-link small text-white"
              onClick={() => SalesForceChat().showChatWindow(
                window.location.pathname.toLowerCase().includes(`/${Locales.French.toLowerCase()}/`)
                  ? SalesforceChatLanguages.French
                  : SalesforceChatLanguages.English,
              )}
            >
              <MarginlessP field={t('ChatWithUs')} />
              <img src={iconChat} className="contact-icon" alt="chat" />
            </Link>
            <a href="/contact-us" className="nav-link small text-white">
              <MarginlessP field={t('ContactUS')} />
              <img src={iconPhone} className="contact-icon" alt="phone" />
            </a>
            <a href="/submit-feedback" className="nav-link small text-white">
              <MarginlessP field={t('SubmitFeedback')} />
              <img src={iconEmail} className="contact-icon" alt="email" />
            </a>
            <span className="nav-link small text-white">
              <MarginlessP field={t('Copyright')} />
              <span
                className="contact-icon"
                style={{
                  fontSize: '24px',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  color: '#FF5F14',
                }}
              >
                ©
              </span>
            </span>
          </nav>
        </div>
      </div>
    </MainFooter>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(Footer);
